
import {PosManagerRepository} from "@/modules/posManager/adapter/PosManagerRepository";

export class PosManagerPort implements PosManagerRepository{
    public async sendArticle(mode: number): Promise<boolean> {
        return this.orderManagerRepository.sendArticle(mode);
    }

    public async sendMCustomers(mode: number): Promise<boolean> {
        return this.orderManagerRepository.sendMCustomers(mode);
    }
    public async receiveTaf(): Promise<boolean> {
        return this.orderManagerRepository.receiveTaf();
    }
    public async receivePersonalzeiten(): Promise<boolean> {
        return this.orderManagerRepository.receivePersonalzeiten();
    }
    public async sendMasterdata(mode: number): Promise<boolean> {
        return this.orderManagerRepository.sendMasterdata(mode);
    }

    public async sendScaleData(mode: number): Promise<boolean> {
        return this.orderManagerRepository.sendScaleData(mode);
    }
    private readonly orderManagerRepository: PosManagerRepository;

    constructor(params: { orderManagerRepository: PosManagerRepository }) {
        this.orderManagerRepository = params.orderManagerRepository;
    }
    public async getConnectionStatus():Promise<number> {
        return this.orderManagerRepository.getConnectionStatus();
    }
    public async isTransmitting():Promise<boolean> {
        return this.orderManagerRepository.isTransmitting();
    }

    public async getReports() : Promise<any[]> {
        return this.orderManagerRepository.getReports();
    }

    public async getReport(args:{reportNr:number, start:Date, end:Date}): Promise<string> {
        return this.orderManagerRepository.getReport(args);
    }

    public async getCashReport(date:string, id:number): Promise<string> {
        return this.orderManagerRepository.getCashReport(date,id);
    }

    public async getBonReport(id:number): Promise<string> {
        return this.orderManagerRepository.getBonReport(id);
    }

    public async sendArticleList(selected:{RecordId:number}[]): Promise<boolean> {
        return this.orderManagerRepository.sendArticleList(selected);
    }

    public getSalesGridList(): any[] {
        return this.orderManagerRepository.getSalesGridList();
    }


}
